var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManualDeposit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeWidth: 12,
    d: "M157 93c0-36.45-29.549-63-66-63-36.45 0-66 29.55-66 66 0 36.451 29.55 66 66 66h6.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M96 54v12m0 60v12m-18-12h27a15.001 15.001 0 1 0 0-30H87a15 15 0 0 1 0-30h27"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C71B8",
    d: "m168.001 144.911 4-.001a4.987 4.987 0 0 1 3.536 1.468 5.027 5.027 0 0 1 1.466 3.55 5.029 5.029 0 0 1-1.462 3.55 4.993 4.993 0 0 1-3.535 1.472l-8 .004a4.987 4.987 0 0 1 3.536 1.468 5.035 5.035 0 0 1 .003 7.1 4.991 4.991 0 0 1-3.535 1.472l-21 .009a19.935 19.935 0 0 1-7.654-1.525 19.993 19.993 0 0 1-6.491-4.35 20.084 20.084 0 0 1-4.338-6.513 20.153 20.153 0 0 1-1.526-7.684c-.005-11.094 5.993-16.067 23.165-24.257a4.987 4.987 0 0 1 3.799-.502 5.016 5.016 0 0 1 3.039 2.343 5.048 5.048 0 0 1 .499 3.815 5.025 5.025 0 0 1-2.334 3.051l-9.497 5.502 26.325-.012a4.988 4.988 0 0 1 3.536 1.469 5.033 5.033 0 0 1 .003 7.1 4.99 4.99 0 0 1-3.535 1.471Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "m151.006 154.959 13-.006c1.326 0 2.598.528 3.536 1.469a5.033 5.033 0 0 1 .003 7.1 4.991 4.991 0 0 1-3.535 1.472l-21 .009a19.935 19.935 0 0 1-7.654-1.525 19.993 19.993 0 0 1-6.491-4.35 20.084 20.084 0 0 1-4.338-6.513 20.153 20.153 0 0 1-1.526-7.684c-.005-11.095 5.993-16.067 23.165-24.258a4.991 4.991 0 0 1 6.838 1.842 5.048 5.048 0 0 1 .499 3.815 5.025 5.025 0 0 1-2.334 3.051l-9.497 5.501 26.325-.011a4.984 4.984 0 0 1 3.536 1.469 5.031 5.031 0 0 1 .003 7.099 4.987 4.987 0 0 1-3.535 1.472l-17 .008"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "m163.005 154.994 8.616-.004c1.428 0 2.797-.528 3.807-1.466 1.009-.938 1.576-2.21 1.575-3.536 0-1.326-.568-2.598-1.578-3.535-1.011-.937-2.381-1.463-3.809-1.463l-4.307.002"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualDeposit);
export default __webpack_public_path__ + "static/media/ManualDeposit.ca8d5af8ab6094056882df4500a441ea.svg";
export { ForwardRef as ReactComponent };